import { SheetPanel } from "./SheetPanel";

// The Sheet and the pricing rules in one place. There is a single row of tabs (All, WooCommerce, GMC, Excluded, Shipping, Taxes, Pricing policy, Versions), kept by the product table itself;
// the Pricing policy and Versions tabs open the policy editor and its saved versions in place of the table. `initial` only chooses which tab is open first.
export function SheetHome({ initial }: { initial?: "policy" | "versions" }) {
  return (
    <div className="sheet-home">
      <SheetPanel initialView={initial} />
    </div>
  );
}
